// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    report: path(ROOTS_DASHBOARD, "/report"),
  },

  desigination: {
    root: path(ROOTS_DASHBOARD, "/desigination"),
    new: path(ROOTS_DASHBOARD, "/desigination/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/desigination/${id}/edit`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    profile: path(ROOTS_DASHBOARD, "/user/profile"),
    account: path(ROOTS_DASHBOARD, "/user/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/user/${id}/replicate`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },

  supplier: {
    root: path(ROOTS_DASHBOARD, "/supplier"),
    new: path(ROOTS_DASHBOARD, "/supplier/new"),
    list: path(ROOTS_DASHBOARD, "/supplier/list"),
    edit: (id) => path(ROOTS_DASHBOARD, `/supplier/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/supplier/${id}/replicate`),
  },

  accounts: {
    root: path(ROOTS_DASHBOARD, "/accounts"),
    purchasedOrder: path(ROOTS_DASHBOARD, "/accounts/purchased-order"),
    purchasedOrderNew: path(ROOTS_DASHBOARD, "/accounts/purchased-order/new"),
    purchasedOrderDetail: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/purchased-order/${id}`),
    purchasedOrderEdit: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/purchased-order/${id}/edit`),
    goodReceiptNote: path(ROOTS_DASHBOARD, "/accounts/good-receipt-note"),
    goodReceiptNoteNew: path(ROOTS_DASHBOARD, "/accounts/good-receipt-note/new"),
    goodReceiptNoteDetail: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/good-receipt-note/${id}`),
    goodReceiptNoteEdit: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/good-receipt-note/${id}/edit`),
    apInvoice: path(ROOTS_DASHBOARD, "/accounts/ap-invoice"),
    apInvoiceNew: path(ROOTS_DASHBOARD, "/accounts/ap-invoice/new"),
    apInvoiceDetail: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/ap-invoice/${id}`),
    apInvoiceEdit: (id) =>
      path(ROOTS_DASHBOARD, `/accounts/ap-invoice/${id}/edit`),
    banking: path(ROOTS_DASHBOARD, "/accounts/banking"),
    bankingNew: path(ROOTS_DASHBOARD, "/accounts/banking/new"),
    bankingDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/banking/${id}`),
    bankingEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/banking/${id}/edit`),
    bankingReturn: path(ROOTS_DASHBOARD, "/accounts/banking-return"),
    bankingReturnNew: path(ROOTS_DASHBOARD, "/accounts/banking-return/new"),
    bankingReturnDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/banking-return/${id}`),
    bankingReturnEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/banking-return/${id}/edit`),
    advancePayment: path(ROOTS_DASHBOARD, "/accounts/advance-payment"),
    advancePaymentNew: path(ROOTS_DASHBOARD, "/accounts/advance-payment/new"),
    advancePaymentDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/advance-payment/${id}`),
    advancePaymentEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/advance-payment/${id}/edit`),
    advancePaymentReturn: path(ROOTS_DASHBOARD, "/accounts/advance-payment-return"),
    advancePaymentReturnNew: path(ROOTS_DASHBOARD, "/accounts/advance-payment-return/new"),
    advancePaymentReturnDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/advance-payment-return/${id}`),
    advancePaymentReturnEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/advance-payment-return/${id}/edit`),
    purchaseOrderReturn: path(ROOTS_DASHBOARD, "/accounts/po-return"),
    purchaseOrderReturnNew: path(ROOTS_DASHBOARD, "/accounts/po-return/new"),
    purchaseOrderReturnDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/po-return/${id}`),
    purchaseOrderReturnEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/po-return/${id}/edit`),
    goodReceiptNoteReturn: path(ROOTS_DASHBOARD, "/accounts/grn-return"),
    goodReceiptNoteReturnNew: path(ROOTS_DASHBOARD, "/accounts/grn-return/new"),
    goodReceiptNoteReturnDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/grn-return/${id}`),
    goodReceiptNoteReturnEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/grn-return/${id}/edit`),
    apInvoiceReturn: path(ROOTS_DASHBOARD, "/accounts/ap-invoice-return"),
    apInvoiceReturnNew: path(ROOTS_DASHBOARD, "/accounts/ap-invoice-return/new"),
    apInvoiceReturnDetail: (id) => path(ROOTS_DASHBOARD, `/accounts/ap-invoice-return/${id}`),
    apInvoiceReturnEdit: (id) => path(ROOTS_DASHBOARD, `/accounts/ap-invoice-return/${id}/edit`),
  },

  stock: {
    display: path(ROOTS_DASHBOARD, "/stock/display"),
    live: path(ROOTS_DASHBOARD, "/stock/live"),
    new: path(ROOTS_DASHBOARD, "/stock/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/stock/${id}/edit`),
    adjustment: path(ROOTS_DASHBOARD, "/stock/adjustment"),
    addAdjustment: path(ROOTS_DASHBOARD, "/stock/adjustment/new"),
    adjustmentEdit: (id) =>
      path(ROOTS_DASHBOARD, `/stock/adjustment/${id}/edit`),
    purchaseOrders: path(ROOTS_DASHBOARD, "/stock/purchaseOrders"),
    addPurchaseOrders: path(ROOTS_DASHBOARD, "/stock/purchaseOrders/new"),
    purchaseOrderEdit: (id) =>
      path(ROOTS_DASHBOARD, `/stock/purchaseOrders/${id}/edit`),
  },

  stocks: {
    requests: path(ROOTS_DASHBOARD, "/stocks/requests"),
    requestDetail: (id) => path(ROOTS_DASHBOARD, `/stocks/requests/${id}`),
    transfers: path(ROOTS_DASHBOARD, "/stocks/transfers"),
    transferNew: path(ROOTS_DASHBOARD, "/stocks/transfers/new"),
    transferDetail: (id) => path(ROOTS_DASHBOARD, `/stocks/transfers/${id}`),
    returns: path(ROOTS_DASHBOARD, "/stocks/returns"),
    returnDetail: (id) => path(ROOTS_DASHBOARD, `/stocks/returns/${id}`),
  },

  inventory: {
    list: path(ROOTS_DASHBOARD, "/inventory"),
  },

  stores: {
    root: path(ROOTS_DASHBOARD, "/stores"),
    list: path(ROOTS_DASHBOARD, "/stores"),
    new: path(ROOTS_DASHBOARD, "/stores/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/stores/${id}/edit`),
  },

  item: {
    list: path(ROOTS_DASHBOARD, "/item/list"),
    new: path(ROOTS_DASHBOARD, "/item/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/item/${id}/edit`),
  },

  catalog: {
    root: path(ROOTS_DASHBOARD, "/catalog"),
    categories: {
      root: path(ROOTS_DASHBOARD, "/catalog/categories"),
      list: path(ROOTS_DASHBOARD, "/catalog/categories"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/categories/${id}/edit`),
    },
    products: {
      root: path(ROOTS_DASHBOARD, "/catalog/products"),
      list: path(ROOTS_DASHBOARD, "/catalog/products"),
      edit: (id) => path(ROOTS_DASHBOARD, `/catalog/products/${id}/edit`),
    },
  },

  invoice: {
    list: path(ROOTS_DASHBOARD, "/invoice/list"),

  },

  settings: {
    list: path(ROOTS_DASHBOARD, "/settings/list"),
    new: path(ROOTS_DASHBOARD, "/settings/new"),
    account: path(ROOTS_DASHBOARD, "/settings/account"),
    kds: path(ROOTS_DASHBOARD, "/settings/kds"),
    edit: (id) => path(ROOTS_DASHBOARD, `/settings/${id}/edit`),
  },
};

export const PATH_DOCS = {
  root: "https://docs.minimals.cc",
  changelog: "https://docs.minimals.cc/changelog",
};

export const PATH_ZONE_ON_STORE =
  "https://mui.com/store/items/zone-landing-page/";

export const PATH_MINIMAL_ON_STORE =
  "https://mui.com/store/items/minimal-dashboard/";

export const PATH_FREE_VERSION =
  "https://mui.com/store/items/minimal-dashboard-free/";

export const PATH_FIGMA_PREVIEW =
  "https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1";
